import src from "IMAGE";
export default { src, width: 5000, height: 5000, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVR42uXKIQEAAADCsLfDEIb+igYUQMwNxSx8hAKFF0DBImsiNgAAAABJRU5ErkJggg=="};
